/**
 * Returns the Tailwind text color class based on utilization percentage.
 * 0-5%: Idle (Slate)
 * 5-80%: Optimal (Emerald)
 * 80-95%: High Load (Amber)
 * >95%: Overloaded (Danger)
 */
export const getUtilizationColor = (utilization: number): string => {
    if (utilization < 5) return 'text-slate-400';
    if (utilization < 80) return 'text-emerald-500';
    if (utilization < 95) return 'text-amber-500';
    return 'text-danger';
};

/**
 * Returns the Tailwind background color class based on utilization percentage.
 */
export const getUtilizationBgColor = (utilization: number): string => {
    if (utilization < 5) return 'bg-slate-200';
    if (utilization < 80) return 'bg-emerald-500';
    if (utilization < 95) return 'bg-amber-500';
    return 'bg-danger';
};
